import { learnerPaths } from '@app/routes/route-paths'
import type { LearnerRouteDefinition } from '@app/routes/learner-route-types'

export const flashcardRouteDefinitions = [
  {
    id: 'flashcards',
    legacyScreen: 3,
    navLabel: 'Flashcards',
    path: learnerPaths.flashcards,
    showInMainMenu: true,
    title: 'Flashcards',
  },
] satisfies readonly LearnerRouteDefinition[]
